import React from "react";
import NavMenu from "./NavMenu";
import Footer from "./Footer";
import AuthCheck from "shared/ui/layout/ui/AuthCheck";

const Layout = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <>
      <NavMenu />
      <AuthCheck>{children}</AuthCheck>
      <Footer />
    </>
  );
};

export default Layout;
